<template>
  <Tabs
    :initial-tab="computedProducts[0]?.id"
    :tabs="
      computedProducts.map((product) => ({
        id: product.id.toString(),
        label: product.product_name ?? 'No Product Name',
      }))
    "
    @change="onTabChange"
    :show-button="computedProducts.length > 1"
  >
    <template v-for="product in computedProducts" #[product.id]>
      <template v-if="product && order && order.id">
        <p class="text-center text-[20px] font-semibold">Order Details</p>
        <div
          class="flex justify-center items-center w-full gap-[30px] mb-[20px] mt-[20px]"
        >
          <button
            class="bg-primary text-white px-3 py-2 rounded-lg"
            @click="() => emits('openOrderPriceModal')"
          >
            <DocumentCurrencyDollarIcon
              class="inline-block mr-1 text-white size-5"
            />
            Order Price
            {{
              `${order?.additional_fields?.currency?.msrp?.code ?? ""} ` +
              `${order?.additional_fields?.currency?.msrp?.symbol ?? ""}` +
              `${(Number(order_item_price) || 0).toFixed(2) ?? 0}`
            }}
          </button>
          <a
            :href="`${appURL}/edit-techpack/${order?.id}?source=new_dashboard`"
            class="bg-primary text-white px-3 py-2 rounded-lg"
          >
            <PencilSquareIcon class="inline-block mr-1 text-white size-5" />
            Edit Techpack
          </a>
          <!-- <button class="bg-primary text-white px-3 py-2 rounded-lg">
            <ArrowDownTrayIcon class="inline-block mr-1 text-white size-5" />
            Download Techpack
          </button> -->
        </div>
        <p class="break-words text-[22px] font-semibold">
          {{ product.product_name ?? "No Product Name" }}
        </p>
        <div class="grid grid-cols-3 gap-4 mt-3 mx-2">
          <div>
            <p class="text-[#5F5F5F] text-base selection">Company:</p>
            <p class="break-words font-semibold">
              {{
                order.hasOwnProperty("company_name") ? order.company_name : ""
              }}
            </p>
          </div>
          <div>
            <p class="text-[#5F5F5F] text-base selection">Customer:</p>
            <p class="break-words font-semibold">
              {{ `${order.customer.first_name} ${order.customer.last_name}` }}
            </p>
          </div>
          <div>
            <p class="text-[#5F5F5F] text-base selection">Email:</p>
            <p class="break-words font-semibold">{{ order.customer.email }}</p>
          </div>
          <div>
            <p class="text-[#5F5F5F] text-base selection">
              Customer Reference No.
            </p>
            <p class="break-words font-semibold">
              {{ order.customer_reference_no ?? "N/A" }}
            </p>
          </div>
          <div>
            <p class="text-[#5F5F5F] text-base selection">PO Num:</p>
            <p class="break-words font-semibold">
              {{ order.additional_fields?.["po_number"] ?? "N/A" }}
            </p>
          </div>
        </div>
        <div class="flex flex-col mt-3 mx-2">
          <div class="w-full">
            <div
              class="w-100 mt-3 border-[1px] border-solid border-[#eeeeee] bg-[#F9F9F9] rounded-xl flex flex-col justify-center items-center p-4 aspect-video"
            >
              <div class="grid grid-cols-2 w-[80%] gap-1 bg-white">
                <template v-if="product.is_custom_product">
                  <img
                    :src="
                      storage_url + '/' + product.custom_product_placeholder
                    "
                    :key="product.custom_product_placeholder + 1"
                    alt=""
                  />
                  <img
                    :src="
                      storage_url + '/' + product.custom_product_placeholder
                    "
                    :key="product.custom_product_placeholder + 2"
                    alt=""
                  />
                </template>
                <template v-else>
                  <img
                    :src="storage_url + '/' + front_preview"
                    :key="front_preview"
                    alt=""
                  />
                  <img
                    :src="storage_url + '/' + back_preview"
                    :key="back_preview"
                    alt=""
                  />
                </template>
              </div>

              <div class="px-3 pb-3 flex mt-4 gap-2 justify-center flex-wrap">
                <button
                  class="btn"
                  v-if="!loadingPreviewImages"
                  @click="downloadImages(product)"
                >
                  <PhotoIcon class="size-5 stroke-[2px] text-[#444444]" />
                  Download Preview Images
                </button>
                <button class="btn" v-else disabled>Please wait...</button>
                <a
                  class="btn"
                  :href="`${storage_url}/${order.design_file}`"
                  target="_blank"
                  v-if="can('download-customer-pdf')"
                >
                  <DocumentTextIcon
                    class="size-5 stroke-[2px] text-[#444444]"
                  />
                  Download PDF</a
                >
                <button
                  class="btn"
                  @click.prevent="() => batchDownloadAssets(product)"
                  v-if="!batch_loading"
                >
                  <FolderArrowDownIcon
                    class="size-5 stroke-[2px] text-[#444444]"
                  />
                  Batch Download Assets
                </button>
                <button class="btn" v-else>Loading...</button>
                <div>
                  <template v-if="order.order_no">
                    <a
                      :href="`${API_URL}/order/${order.id}/product/${product.id}/export`"
                      :download="`order_${order.order_no}_product_${product.product_name}.xlsx`"
                      class="btn"
                    >
                      <QueueListIcon
                        class="size-5 stroke-[2px] text-[#444444]"
                      />
                      Download Excel sheet
                    </a>
                  </template>
                  <template v-else>
                    <a
                      :href="`${API_URL}/order/${order.id}/product/${product.id}/export`"
                      :download="`order_${getCurrentDatetime()}_product_${product.product_name}.xlsx`"
                      class="btn"
                    >
                      <QueueListIcon
                        class="size-5 stroke-[2px] text-[#444444]"
                      />
                      Download Excel sheet
                    </a>
                  </template>
                </div>
              </div>
            </div>
            <div
              class="w-100 mt-3 border-[1px] border-solid border-[#eeeeee] bg-[#F9F9F9] rounded-xl flex flex-col justify-center items-center p-4 aspect-video"
            >
              <h4 class="text-2xl font-semibold mb-2">Production Images</h4>
              <template
                v-if="
                  product &&
                  product.hasOwnProperty('production_url') &&
                  product.production_url
                "
              >
                <template v-if="order.order_no">
                  <div
                    @click="
                      downloadProductionFile(
                        product.svg_url,
                        `${order.order_no}.svg`,
                      )
                    "
                  >
                    <img
                      v-if="product.svg_url"
                      :src="`${storage_url}/${product.svg_url}`"
                      class="production-image"
                      style="height: 100%; width: 100%"
                    />
                    <span
                      v-else
                      v-html="production_content"
                      class="production-image"
                    ></span>
                  </div>
                </template>
                <template v-else>
                  <div
                    @click="
                      downloadProductionFile(
                        product.svg_url,
                        `${getCurrentDatetime()}.svg`,
                      )
                    "
                  >
                    <img
                      v-if="product.svg_url"
                      :src="`${storage_url}/${product.svg_url}`"
                      class="production-image"
                      style="height: 100%; width: 100%"
                    />
                    <span
                      v-else
                      v-html="production_content"
                      class="production-image"
                    ></span>
                  </div>
                </template>
              </template>
              <div class="grid grid-cols-2 w-[80%] gap-1 bg-white"></div>
            </div>
          </div>
        </div>
        <div class="w-full order-detail-roster my-5">
          <h4 class="text-2xl font-semibold mb-2">Product Roster</h4>
          <template
            v-if="
              product &&
              Object.prototype.hasOwnProperty.call(
                product,
                'product_roster_detail',
              ) &&
              product.product_roster_detail.length > 0
            "
          >
            <DataTable
              :key="product.id"
              :data="product.product_roster_detail"
              :columns="roster_headers"
              :showPagination="product.product_roster_detail.length > 10"
              :show-actions-column="true"
              :total-items="product.product_roster_detail.length"
              :current-pagination-info="{
                page: 1,
                per_page: 10,
                sort_by: 'size',
                sort_order: 'asc',
                items_for: 'all',
                search: '',
              }"
            >
              <template #actions="{ row }">
                <button
                  class="btn btn-secondary"
                  @click="getSizeSvg(row, product)"
                >
                  Download SVG
                </button>
              </template>
            </DataTable>
          </template>
        </div>
        <div class="w-full mt-2">
          <h4 class="text-2xl font-semibold mb-2">Custom Names</h4>
          <DataTable
            :key="product.id"
            :data="product_texts"
            :columns="custom_text_headers"
            :showPagination="product_texts.length > 10"
            :total-items="product_texts.length"
            :current-pagination-info="{
              page: 1,
              per_page: 10,
              sort_by: 'size',
              sort_order: 'asc',
              items_for: 'all',
              search: '',
            }"
          />
        </div>
        <div class="w-full my-2">
          <h4 class="text-2xl font-semibold mb-2">Custom Numbers</h4>
          <DataTable
            :key="product.id"
            :data="product_numbers"
            :columns="custom_text_headers"
            :showPagination="product_numbers.length > 10"
            :total-items="product_numbers.length"
            :current-pagination-info="{
              page: 1,
              per_page: 10,
              sort_by: 'size',
              sort_order: 'asc',
              items_for: 'all',
              search: '',
            }"
          />
        </div>
        <div class="w-full pt-2 my-2">
          <h4 class="text-2xl font-semibold mb-2">Custom Logos</h4>
          <template v-if="product && product.custom_logos.length > 0">
            <DataTable
              :key="product.id"
              :data="custom_logos"
              :columns="custom_logos_headers"
              :showPagination="custom_logos.length > 10"
              :total-items="custom_logos.length"
              :current-pagination-info="{
                page: 1,
                per_page: 10,
                sort_by: 'size',
                sort_order: 'asc',
                items_for: 'all',
                search: '',
              }"
            />
          </template>
        </div>
        <div class="w-full pt-2 my-2">
          <h4 class="text-2xl font-semibold mb-2">SVG Groups</h4>
          <template
            v-if="
              product &&
              product.hasOwnProperty('svg_groups') &&
              product.svg_groups.length > 0
            "
          >
            <DataTable
              :key="product.id"
              :data="product.svg_groups"
              :columns="svg_group_headers"
              :showPagination="product.svg_groups.length > 10"
              :total-items="product.svg_groups.length"
              :current-pagination-info="{
                page: 1,
                per_page: 10,
                sort_by: 'size',
                sort_order: 'asc',
                items_for: 'all',
                search: '',
              }"
            />
          </template>
          <template v-else="">
            <div>
              <div class="w-full">No Custom Logos Exists</div>
            </div>
          </template>
        </div>
      </template>
    </template>
  </Tabs>
</template>

<script setup lang="ts">
import DataTable from "@/components/Shared/DataTable.vue";
import Tabs from "@/components/Shared/Tabs.vue";
import { can, getCurrentDatetime } from "@/composables";
import { useProductDetails } from "@/composables/useProductDetails";
import { FactoryProduct, OrderDetail } from "@/models";
import {
  ArrowDownTrayIcon,
  DocumentTextIcon,
  FolderArrowDownIcon,
  PhotoIcon,
  QueueListIcon,
} from "@heroicons/vue/24/outline";
import {
  DocumentCurrencyDollarIcon,
  PencilSquareIcon,
} from "@heroicons/vue/24/solid";
import { onMounted } from "vue";
const props = defineProps<{
  factoryProducts: FactoryProduct[];
  order: OrderDetail;
  order_item_price?: number;
}>();
const emits = defineEmits(["openOrderPriceModal"]);
const appURL = import.meta.env.VITE_VUE2_APP_URL;
onMounted(() => {
  loadOrderDetails(props.factoryProducts[0], false, props.order);
});
const onTabChange = (tabId: string) => {
  const productIndex = props.factoryProducts.findIndex(
    (product) => product.id.toString() === tabId,
  );
  if (productIndex !== -1) {
    loadOrderDetails(props.factoryProducts[productIndex], false, props.order);
  }
};
const {
  product_numbers,
  product_texts,
  custom_logos,
  roster_headers,
  custom_text_headers,
  custom_logos_headers,
  svg_group_headers,
  API_URL,
  storage_url,
  batch_loading,
  loadingPreviewImages,
  front_preview,
  back_preview,
  computedProducts,
  production_content,
  batchDownloadAssets,
  downloadImages,
  loadOrderDetails,
  getSizeSvg,
  downloadProductionFile,
} = useProductDetails(props);
</script>
<style lang="scss" scoped>
.btn {
  @apply px-2 py-2 flex gap-2 justify-between items-center rounded-lg capitalize text-[#444444] bg-[#EDEDED];
}
</style>
